<template>
  <div>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset">
        {{ $t('home_new_folder_title') }}
      </b-card-text>
    </div>
    <b-list-group class="mt-3 rounded-0">
      <b-list-group-item class="bg-transparent">
        <b-form-group :label="$t('home_new_folder_label_1')" label-for="new-organisation-folder">
          <b-form-input
            id="new-organisation-folder"
            v-model="name"
            v-invalid-char-filter="isValid => (folderNameValid = isValid)"
            :placeholder="$t('home_new_folder_label_2')"
            @keydown.enter="validateName && onClickCreate()"
          />
        </b-form-group>
        <InvalidCharMsg :visible="!folderNameValid" />
      </b-list-group-item>
      <b-list-group-item class="bg-transparent right-align">
        <b-button
          v-if="showCreateButton"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
          :disabled="!validateName"
          @click="onClickCreate()"
        >
          {{ $t('btn_create') }}
        </b-button>
        <b-button v-else variant="primary" disabled class="d-flex">
          <b-spinner small></b-spinner>
          <span>{{ $t('loading') }}...</span>
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BButton, BListGroup, BListGroupItem, BFormGroup, BFormInput, BCardText, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InvalidCharMsg from '@/components/InvalidCharMsg.vue'
export default {
  components: {
    BButton,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BCardText,
    BSpinner,
    InvalidCharMsg
  },
  directives: {
    Ripple
  },
  data() {
    return {
      showCreateButton: true,
      folderNameValid: true
    }
  },
  computed: {
    ...mapState('homeAddNew', ['entityName']),
    name: {
      get() {
        return this.entityName
      },
      set(value) {
        this.$store.dispatch('homeAddNew/setEntityName', { value })
      }
    },
    validateName() {
      if (this.name === ' ' || this.name === null || !this.name) {
        return false
      } else {
        return this.folderNameValid
      }
    }
  },
  methods: {
    async onClickCreate() {
      this.showCreateButton = false
      await this.$store.dispatch('homeAddNew/createFolder', {
        self: this,
        vaultId: this.$route.params.vaultId,
        folderId: this.$route.params.folderId,
        name: this.name
      })
      this.$store.dispatch('userProfile/getDiskUsage', { self: this })
      this.showCreateButton = true
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group-item {
  border: none !important;
}
</style>
